import { ChatOutlined } from "@mui/icons-material";
import { Box, CircularProgress, Typography, Grid, Badge } from "@mui/material";
import { StudyQuestion } from "../models";

interface StudyQuestionsGridProps {
  studyQuestions: StudyQuestion[] | undefined;
  isLoadingQuestions: boolean;
  askDeepchatQuestion: (question: string, question_id?: string, numOfResponses?: number) => void;
}

export default function StudyQuestionsGrid({
  studyQuestions,
  isLoadingQuestions,
  askDeepchatQuestion,
}: StudyQuestionsGridProps) {
  return (
    <>
      {isLoadingQuestions ? (
        <Box
          sx={{
            display: "flex",
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box
          sx={{
            paddingRight: "10px",
            flex: 1, // Allow the box to grow and shrink within available space
            overflowY: "auto",
            maxHeight: "calc(100vh - 355px)", // I give up, this is the best I got for a scrolling tile set but fixed chat input
          }}
        >
          <Box sx={{ overflowY: "auto", minHeight: 0 }}>
            <Typography variant="h6" sx={{ marginBottom: "1rem" }}>
              Not sure what to ask?
            </Typography>
            <Box>
              {(studyQuestions ?? []).length > 0 ? (
                <Grid container spacing={2} direction={"row"}>
                  {(studyQuestions ?? []).map((question, i) => {
                    return (
                      <Grid item xs={12} sm={6} md={4} key={i}>
                        <Box
                          flexDirection={"row"}
                          gap={3}
                          onClick={() => {
                            askDeepchatQuestion(question.question_title, question.question_id, question.responses);
                          }}
                          sx={{
                            background: "#EFF0F0",
                            padding: "20px",
                            borderRadius: "10px",
                            display: "flex",
                            cursor: "pointer",
                            height: "100%",
                          }}
                        >
                          <Badge
                            badgeContent={question.responses}
                            color="secondary"
                            sx={{
                              "& .MuiBadge-badge": {
                                color: "white",
                              },
                            }}
                          >
                            <ChatOutlined fontSize="large" sx={{ color: "#003087", marginTop: "5px" }} />
                          </Badge>
                          <Typography variant="h6" sx={{ fontSize: "14px" }}>
                            {question.question_title}
                          </Typography>
                        </Box>
                      </Grid>
                    );
                  })}
                </Grid>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography variant="h6" sx={{ fontSize: "20px", color: "#13294B" }}>
                    No Questions Available
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
}
